import React, { FC } from 'react';
import s from './Switcher.scss';
import { VIEW_MODE } from '../../../utils/helpers';
import { SwitcherButton } from './SwitcherButton/SwitcherButton';
import { WithTranslation, withTranslation } from '@wix/wix-i18n-config';
import { useTemplateContext } from '../../../context/TemplateContext';
import DesktopIcon from './DesktopIcon.svg';
import TabletIcon from './TabletIcon.svg';
import MobileIcon from './MobileIcon.svg';

interface Props extends WithTranslation {
  viewMode: VIEW_MODE;
  toggleViewMode: (viewMode: VIEW_MODE) => any;
}

export const SwitcherCmp: FC<Props> = ({ viewMode, toggleViewMode, t }) => {
  const { isStudio2 } = useTemplateContext();

  return (
    <div className={s.switcher}>
      <SwitcherButton
        viewMode={VIEW_MODE.DESKTOP}
        activeView={viewMode}
        tooltip={t('toolbar.tooltip.desktop')}
        toggleViewMode={toggleViewMode}
      >
        <DesktopIcon />
      </SwitcherButton>
      {!isStudio2 && (
        <SwitcherButton
          viewMode={VIEW_MODE.TABLET}
          activeView={viewMode}
          tooltip={t('toolbar.tooltip.tablet')}
          toggleViewMode={toggleViewMode}
        >
          <TabletIcon />
        </SwitcherButton>
      )}
      <SwitcherButton
        viewMode={VIEW_MODE.MOBILE}
        activeView={viewMode}
        tooltip={t('toolbar.tooltip.mobile')}
        toggleViewMode={toggleViewMode}
      >
        <MobileIcon />
      </SwitcherButton>
    </div>
  );
};

export const Switcher = withTranslation()(SwitcherCmp);
